import React, { HTMLAttributes, ReactNode } from 'react';

interface MasonryGridProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  items: ReactNode[];
}

import './style.scss';

const MasonryGrid: React.FC<MasonryGridProps> = ({ items }) => (
  items.length === 2
    ? (
      <div className="MasonryGrid two row">
        <ul className="left col-md-6">
          <li>{items[0]}</li>
        </ul>
        <ul className="right col-md-6">
          <li>{items[1]}</li>
        </ul>
      </div>
    )
    : (
      <div className="MasonryGrid four row">
        <ul className="left col-md-6">
          <li>{items[0]}</li>
          <li>{items[2]}</li>
        </ul>
        <ul className="right col-md-6">
          <li>{items[1]}</li>
          <li>{items[3]}</li>
        </ul>
      </div>
    )
);

export default MasonryGrid;
